import Header from "./Header";
import Loading from "./Loading";
import {use, useEffect, useState} from "react";
import {properties} from "../properties";
import {useNavigate} from "react-router-dom";
import {isUserLoggedIn} from "../service/AuthService";
import {ftAccessToken} from "../constants/Constants";

function NetworkGraph() {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    const navigate = useNavigate();
    const [smallScreen, setSmallScreen] = useState(window.innerWidth < 991);
    const [loading, setLoading] = useState(!smallScreen);

    useEffect(() => {
        if (!isUserLoggedIn()) {
            navigate("/")
        }
    }, [])


    useEffect(() => {
        const onResize = () => setSmallScreen(window.innerWidth < 991);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    return (
        <div>
            <Header page="submission"/>

            {loading && <Loading/>} {/* Show loading while iframe loads */}

            <div className="body" style={{display: loading ? "none" : "block"}}>
                <div className="heading">Network Discovery</div>

                {smallScreen ? (
                    <div>
                        <br/>
                        <div>Network Discovery is not available on small screens or mobile devices.</div>
                    </div>
                ) : (
                    <iframe
                        className="fade-in"
                        title="graph"
                        src={`${properties.host}/graph/${id}?accessToken=${localStorage.getItem(ftAccessToken)?.replaceAll('"', '')}`}
                        onLoad={() => setLoading(false)}
                        style={{
                            width: "100%",
                            height: "75vh",
                            border: "none"
                        }}
                    />

                )}
            </div>
            {!loading &&
                <button onClick={() => navigate("/submission?id=" + id)}
                        className={"back-button fade-in"}
                ><span className={"back-button-text"}>&larr;</span>
                </button>
            }
        </div>
    );
}

export default NetworkGraph;
